var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDentalVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "63px",
    viewBox: "0 0 62 63",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Dental") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Dental Icon")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6418,59.2313 C38.6508,60.3223 40.2768,60.5493 41.5608,59.8003 C45.1618,57.7023 52.1128,51.1183 56.6748,38.1933 C59.1448,31.1983 59.9858,24.6293 59.7088,19.0403 C59.2408,9.6183 55.5008,0.2503 29.9498,0.2503 C4.3988,0.2503 0.7688,9.6183 0.3008,19.0403 C0.0238,24.6293 0.8648,31.1983 3.3348,38.1933 C7.9258,51.2013 14.9368,57.7723 18.5168,59.8403 C19.7778,60.5683 21.3788,60.3003 22.3668,59.2313 L25.7768,54.4783 C28.0558,52.0123 31.9538,52.0123 34.2328,54.4783 L37.6418,59.2313 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0608,19.4974 C9.0608,19.4974 10.1248,8.8514 21.8358,8.8514",
    id: "Stroke-3",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentalVertical);
export default __webpack_public_path__ + "static/media/dental-vertical.847b25be.svg";
export { ForwardRef as ReactComponent };